import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Products from "../components/Products";
import Story from "../components/Story";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#FAF5EC]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Products />
        <Story />
        <Newsletter />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default Home;
